var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40.5 35.908a5.143 5.143 0 1 0 0-10.285 5.143 5.143 0 0 0 0 10.285m0 2a7.143 7.143 0 1 0 0-14.285 7.143 7.143 0 0 0 0 14.285M40.522 41.767c-4.4.097-9.022 3.756-9.022 11.15 0 1.066.787 2.056 2.53 2.83 1.71.758 4.061 1.161 6.47 1.161s4.76-.403 6.47-1.162c1.743-.773 2.53-1.763 2.53-2.83 0-3.956-1.185-6.76-2.856-8.553a8.06 8.06 0 0 0-6.122-2.596M48.106 43c2.08 2.23 3.394 5.555 3.394 9.918 0 2.26-1.713 3.767-3.72 4.657-2.04.906-4.689 1.334-7.28 1.334s-5.24-.428-7.28-1.334c-2.007-.89-3.72-2.396-3.72-4.657 0-8.365 5.378-13.026 10.978-13.15A10.06 10.06 0 0 1 48.106 43",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40.5 68.766c15.464 0 28-12.537 28-28 0-15.464-12.536-28-28-28s-28 12.536-28 28 12.536 28 28 28m0 2c16.569 0 30-13.432 30-30 0-16.569-13.431-30-30-30-16.568 0-30 13.431-30 30 0 16.568 13.432 30 30 30",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;